import { Component, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';

/**
 * Пункт меню sidebar: иконка, заголовок, подзаголовок.
 * Может быть ссылкой (routerLink) или кнопкой (click).
 */
@Component({
  selector: 'app-sidebar-nav-item',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, LucideAngularModule],
  templateUrl: './sidebar-nav-item.component.html',
})
export class SidebarNavItemComponent {
  icon = input.required<string>();
  title = input.required<string>();
  subtitle = input.required<string>();
  /** Ссылка для навигации. Если не задана — рендерится кнопка. */
  routerLink = input<string | undefined>();
  /** Бейдж справа от заголовка (опционально). */
  badge = input<number | undefined>();

  clicked = output<void>();

  protected onAction(): void {
    this.clicked.emit();
  }
}
